module.exports = __webpack_public_path__ + "static/media/CNX-NIFTY-JUNIOR.ad06e3a6.txt";